/* eslint-disable */
import _ from 'lodash';

const { round } = require('./utils');

const compQuote = ({
  availability: {
    componentClassIII,
    componentClassIV,
  },
  coverageLevel,
  declaredShare,
  simPrices,
  compIns,
  loadingFactor,
  expectedPrice,
  milkProduction,
  simYieldAdjustmentFactor,
  calculating,
}, { subsidyPercent }) => {

  let zeroQuote = {
    expRevGuarantee: 0,
    liability: 0,
    totalPremiumAmount: 0,
    subsidyAmount: 0,
    producerPremiumAmount: 0,
  };

  // if (calculating) {
  //   console.log('Bypassing quote because the app is still calculating.');
  //   return zeroQuote;
  // };

  const {
    butterFatTest,
    proteinTest,
    weightingFactor,
  } = compIns;

  // Eject and return all 0s if the quote is 100% for a component class
  // that is unavailable

  if (
    (parseFloat(weightingFactor) == 0 && componentClassIV ||
    parseFloat(weightingFactor) == 100 && componentClassIII) &&
    (!componentClassIV && !componentClassIII)
  ) {
    console.log('Component weighting selection conflicts with availability.');
    return zeroQuote;
  }

  const butterFatSimPrices = _.get(simPrices, `butterFat`, null);
  const proteinSimPrices = _.get(simPrices, `protein`, null);
  const otherSolidsSimPrices = _.get(simPrices, `otherSolids`, null);
  const nonfatSolidsSimPrices = _.get(simPrices, `nonfatSolids`, null);
  if (!butterFatSimPrices || !proteinSimPrices || !otherSolidsSimPrices || !nonfatSolidsSimPrices) {
    return 0;
  }

  const calcSimRevAmounts = () => {
    const cpwf = 1 - (parseFloat(weightingFactor) / 100);

    return SEQUENCE.map((seq) => {
      const butterFatSimPrice = _.get(simPrices, `butterFat[${seq}]`, null);
      const proteinSimPrice = _.get(simPrices, `protein[${seq}]`, null);
      const otherSolidsSimPrice = _.get(simPrices, `otherSolids[${seq}]`, null);
      const nonfatSolidsSimPrice = _.get(simPrices, `nonfatSolids[${seq}]`, null);

      if (!butterFatSimPrice === null || !proteinSimPrice === null || !otherSolidsSimPrice === null || !nonfatSolidsSimPrice === null) {
        return console.log(`Missing some data: \n
          butterFat: ${butterFatSimPrice}, \n
          proteinSimPrice: ${proteinSimPrice}\n
          otherSolidsSimPrice: ${otherSolidsSimPrice}\n
          nonfatSolidsSimPrice: ${nonfatSolidsSimPrice}
        `);
      }

      return round(
        (
          round(
            cpwf *
            (
              round(butterFatSimPrice * butterFatTest) +
              round(proteinSimPrice * proteinTest) +
              round(otherSolidsSimPrice * 5.7)
            )
          ) +
          round(
            (1 - cpwf) *
            (
              round(butterFatSimPrice * butterFatTest) +
              round(nonfatSolidsSimPrice * (proteinTest + 5.7))
            )
          )
        ) *
        (milkProduction * simYieldAdjustmentFactor[seq] / 100.00)
      , 0);
    });
  };

  const simRevAmounts = calcSimRevAmounts();

  const calcExpRevAmount = () => {
    const cpwf = 1 - (parseFloat(weightingFactor) / 100);
    const {
      butterfat: butterFatExpPrice,
      protein: proteinFatExpPrice,
      otherSolids: otherSolidsExpPrice,
      nonfatSolids: nonfatSolidsExpPrice,
    } = expectedPrice;

    const result = round((round(cpwf * (round(butterFatExpPrice.avg * butterFatTest)
      + round(proteinFatExpPrice.avg * proteinTest) + round(otherSolidsExpPrice.avg * 5.7)))
      + round((1 - cpwf) * (round(butterFatExpPrice.avg * butterFatTest)
      + round(nonfatSolidsExpPrice.avg * (proteinTest + 5.7))))) * (milkProduction / 100.00));

    return round(result, 0);
  };

  const expRevAmount = calcExpRevAmount();
  const expRevGuarantee = Math.ceil((expRevAmount * coverageLevel) / 100) || 0;
  const simulatedLoss = simRevAmounts.map((value) => round(Math.max(expRevGuarantee - value, 0), 2));
  const sum = simulatedLoss.reduce((a, b) => a + b, 0);
  const simulatedLossAverage = round(Math.max((sum / 5000.00), (0.02 * milkProduction / 100.00)), 2);
  const preliminaryTotalPremium = Math.ceil(simulatedLossAverage * declaredShare * compIns.protectionFactor) || 0;
  const totalPremiumAmount = Math.ceil(preliminaryTotalPremium * loadingFactor) || 0;
  const liability = expRevGuarantee * declaredShare * compIns.protectionFactor || 0;
  const subsidyAmount = Math.ceil(totalPremiumAmount * subsidyPercent) || 0;
  const producerPremiumAmount = Math.max(Math.ceil(totalPremiumAmount - subsidyAmount), 1) || 0;

  console.log({
    expRevGuarantee,
    liability,
    totalPremiumAmount,
    subsidyAmount,
    producerPremiumAmount
  });
  return {
    expRevGuarantee,
    liability,
    totalPremiumAmount,
    subsidyAmount,
    producerPremiumAmount
  };
};

export default compQuote;
